import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { templateDuplicate } from 'api/endpoints/template';
import { ENUM_SURVEY_STATUS } from 'constants/enum';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';
import { toastError } from 'lib/toast';
import AppRoutes from 'routes/routes';
import { setLoading } from 'store/actions/common';

const useTemplate = () => {
  const navigator = useNavigate();
  const dispatch = useDispatch();

  const makeDuplicateTemplate = (id, data) => {
    const fData = {
      title: data?.title || TEXT_CREATE_SURVEY.CHILD_5_YEAR_OLD_CHECKUP,
      status: ENUM_SURVEY_STATUS.DRAFT,
    };
    dispatch(setLoading({ isOpen: true }));
    return templateDuplicate(id, fData)
      .then((response) => {
        navigator(AppRoutes.surveyViewFn(response.data.survey_id), { state: { openSchedule: true } });
        dispatch(setLoading({ isOpen: false }));
        return true;
      })
      .catch((error) => {
        toastError(error?.message);
        dispatch(setLoading({ isOpen: false }));
      });
  };

  return { makeDuplicateTemplate };
};

export default useTemplate;
